import { reactive } from 'vue';
import { readBooleanMap } from './persistedState';

const entityStorageKey = 'chronis.explorer.entity-state.v2';
const referenceStorageKey = 'chronis.explorer.reference-state.v2';

function readState(storageKey: string) {
  if (typeof localStorage === 'undefined') return {};
  return readBooleanMap(localStorage, storageKey);
}

function persist(storageKey: string, state: Record<string, boolean>) {
  if (typeof localStorage === 'undefined') return;
  try { localStorage.setItem(storageKey, JSON.stringify(state)); } catch { /* Speicher ist optional. */ }
}

export const explorerEntityExpansion = reactive(readState(entityStorageKey));
export const explorerReferenceExpansion = reactive(readState(referenceStorageKey));

export function setExplorerEntityExpanded(entityId: string, expanded: boolean) {
  explorerEntityExpansion[entityId] = expanded;
  persist(entityStorageKey, explorerEntityExpansion);
}

export function setExplorerReferenceExpanded(referenceKey: string, expanded: boolean) {
  explorerReferenceExpansion[referenceKey] = expanded;
  persist(referenceStorageKey, explorerReferenceExpansion);
}
